import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2.202 27.469c-.024 1.695.014 2.604.164 3.627l.014.22.007.137c.051.915.132 1.193.413 1.527.48.574 1.199.78 2.812.748 1.077-.022 2.205-.232 3.484-.645.456-.146.644-.207.844-.274.92-.309 1.534-.576 2.057-.896.86-.527 1.325-1.129 1.463-1.863.065-.349.075-.658.041-1.376l-.01-.197a13 13 0 0 1-.016-.565c-.006-1.143.127-2.135.42-3.035 1.354-4.181 5.712-7.247 10.318-7.275 2.767.114 5.578 1.411 7.454 3.45 1.512 1.643 2.493 3.724 2.756 5.867.072.582.087 1.066.078 2.22l-.002.524c.001.857.232 1.461.754 1.994.544.555 1.081.869 2.52 1.464l.17.071.168.07c1.332.557 2.225.842 3.13.994 1.334.224 2.332.185 3.106-.119.385-.15.668-.39.836-.699.159-.29.211-.518.277-1.278.018-.205.018-.205.038-.386.484-3.216.4-5.37-.31-7.313-1.177-3.221-3.99-5.844-8.209-7.722-3.739-1.664-8.155-2.53-12.789-2.52-2.582-.1-5.299.123-7.962.654-3.79.754-6.999 2.1-9.465 3.992C4.74 20.42 3.315 22.363 2.646 24.5c-.283.906-.429 1.88-.444 2.97m-1.65-3.626c.809-2.585 2.505-4.9 4.874-6.72 2.752-2.112 6.271-3.587 10.373-4.404 2.83-.563 5.72-.8 8.43-.694 4.889-.013 9.611.913 13.643 2.708 4.721 2.102 7.976 5.136 9.379 8.975.855 2.34.952 4.845.424 8.351-.011.1-.011.1-.028.29-.09 1.036-.203 1.53-.537 2.14-.422.776-1.11 1.358-1.961 1.693-1.198.469-2.58.524-4.272.24-1.095-.185-2.139-.518-3.612-1.134l-.163-.068-.17-.07c-1.688-.7-2.453-1.146-3.247-1.957-.937-.956-1.379-2.113-1.382-3.525l.002-.546c.009-1.066-.004-1.471-.061-1.936-.206-1.681-.987-3.338-2.192-4.648-1.481-1.608-3.744-2.652-5.878-2.742-3.623.024-7.134 2.493-8.191 5.757-.215.663-.317 1.425-.313 2.35 0 .122.005.253.015.472l.01.196c.04.873.025 1.333-.077 1.883-.26 1.393-1.117 2.5-2.475 3.331-.683.419-1.44.748-2.504 1.105a63 63 0 0 1-.87.283c-1.47.475-2.808.724-4.113.75-2.213.044-3.539-.335-4.54-1.533-.64-.764-.846-1.47-.92-2.816l-.008-.132c-.164-1.184-.207-2.2-.181-4.004.018-1.295.194-2.48.544-3.595",
      clipRule: "evenodd"
    }
  )
);
var SvgHangUpOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var HangUpOutlined_default = SvgHangUpOutlined;

export { HangUpOutlined_default as default };
